/**
 * Convert a ASCII string to byte buffer
 * For example "01" will give [0x30, 0x31]
 * @param str
 */
export function asciiStringToByteBuffer(str) {
    const bufView = new Uint8Array(str.length);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return bufView;
}
export function typedArrayToBuffer(array) {
    return array.buffer.slice(array.byteOffset, array.byteLength + array.byteOffset);
}
/**
 * Convert a byte buffer to the hexadecimal string representation
 * For example [0x1, 0x2] will returns string "0102"
 * @param buffer
 */
export function bufferToHexString(buffer) {
    if (!buffer) {
        return '';
    }
    const result = Array.prototype.map
        .call(buffer, (x) => ('00' + x.toString(16)).slice(-2))
        .join('');
    return result.toUpperCase();
}
/**
 * Convert a byte buffer to the binary string representation
 * For example [0x1, 0x2] will returns string "0000000100000002"
 * @param buffer
 */
export function bufferToBinaryString(buffer) {
    const result = Array.prototype.map
        .call(buffer, (x) => {
        let res = '';
        for (let i = 7; i >= 0; i--) {
            res += ((0x1 << i) & x) > 0 ? '1' : '0';
        }
        return res;
    })
        .join('');
    return result;
}
// export function hexStringToBufferOld(hexString: string): Uint8Array {
//     var bytes = new Uint8Array(Math.ceil(hexString.length / 2));
//     for (var i = 0; i < bytes.length; i++)
//         bytes[i] = parseInt(hexString.substr(i * 2, 2), 16);
//     return bytes;
// }
/**
 * Convert an hexadecimal string to a buffer
 * For example "0102" or "01 02" will returns string [0x1, 0x2]
 * @param hexString
 */
export function hexStringToBuffer(hexString) {
    let pPrev;
    hexString = hexString.trim();
    let i = hexString.startsWith('0x') ? 2 : 0;
    const data = [];
    for (; i < hexString.length; i++) {
        switch (hexString[i]) {
            case ' ':
            case '\t':
                continue;
            default:
                if (pPrev !== undefined) {
                    const value = parseInt(pPrev + hexString[i], 16);
                    if (isNaN(value)) {
                        throw new Error(`Invalid hexadecimal string format for input string "${hexString}"`);
                    }
                    data.push(value);
                    pPrev = undefined;
                }
                else {
                    pPrev = hexString[i];
                }
        }
    }
    if (pPrev !== undefined) {
        data.push(parseInt(pPrev, 16));
    }
    return Uint8Array.from(data);
}
/**
 * Converts data to an ascii string
 * @param data
 */
export function bufferToAsciiString(data) {
    return String.fromCharCode.apply(null, data);
}
// /**
//  * Converts data to an unsigned number
//  * @param data
//  * @param sizeOf
//  * @param lsb
//  */
// export function toUnsignedInt(
//     data: Uint8Array,
//     sizeOf: number = 4,
//     lsb: boolean = true
// ) {
//     var ret = 0;
//     if (lsb) {
//         data = data.reverse();
//     }
//     for (var i = 0; i < data.length && i < sizeOf; i++) {
//         ret = (ret << 8) + (data[i] & 0xff);
//     }
//     return ret;
// }
